export const internet = {
  loginreq: "loginreq_yes",
  no_loginreq: "loginreq_no",
  daddr: "DAddr",
  pdaddr: "PDAddr",
  tdaddr: "tdaddr",
  wan_assign_dynamic: "WANAssign_Dynamic",
  wan_assign_fixed: "WANAssign_Fixed",
  wpethr: "WPethr",
  myip: "myip_",
  mymask: "mymask_",
  mygw: "mygw_",
  pptp_dns_assign_auto: "DNSAssign_autodns",
  pptp_dns_assign_static: "DNSAssign_these",
  primary_dns_address: "DAddr",
  second_dns_address: "PDAddr",
};

export default internet;
